import { tss } from 'tss-react';

export const useStyles = tss.create({
	button: {
		cursor: 'pointer',
	},
	icon: {
		color: 'grey',
	},
});
